import { buildQueryString } from './../../../helpers/src/QueryHelper';
import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { ApiResult } from '@crema/models/Apps';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const WAREHOUSE_URL = '/api/warehouses';

export const warehouseApi = createApi({
  reducerPath: 'warehouse.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['warehouseInfo'],
  endpoints: (builder) => ({
    getListWarehouse: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        type = '',
        country = '',
        status = '',
        name = '',
        sort = '',
      }) => {
        const queryString = buildQueryString({
          pageNo,
          pageSize,
          type,
          country,
          status,
          name,
          sort,
        });
        return { url: `${WAREHOUSE_URL}?${queryString}` };
      },
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        } as ApiResult;
      },
      keepUnusedDataFor: 5,
      providesTags: ['warehouseInfo'],
    }),
    getWarehouseById: builder.query({
      query: (id) => ({ url: `${WAREHOUSE_URL}/${id}` }),
      providesTags: ['warehouseInfo'],
    }),
    addWarehouse: builder.mutation({
      query: (body) => ({
        url: `${WAREHOUSE_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['warehouseInfo'],
    }),
    deleteWarehouse: builder.mutation({
      query: (id) => ({
        url: `${WAREHOUSE_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['warehouseInfo'],
    }),
    updateWarehouse: builder.mutation({
      query: (data) => ({
        url: `${WAREHOUSE_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['warehouseInfo'],
    }),
  }),
});

export const {
  useGetListWarehouseQuery,
  useGetWarehouseByIdQuery,
  useAddWarehouseMutation,
  useDeleteWarehouseMutation,
  useUpdateWarehouseMutation,
} = warehouseApi;
